import React from 'react';

const CodeOfConductSection = () => {
  return (
    <section className="code-of-conduct-section">
      <div className="container">
        <h2 className="section-title">Code of Conduct</h2>
        <p className="coc-summary">
          We value respectful and constructive interaction with all audiences. Please read our <a href="https://github.com/ElmentorProgram/.github/blob/main/CODE_OF_CONDUCT.md" target="_blank" rel="noopener noreferrer">Code of Conduct</a> to understand how we ensure a safe and welcoming environment for everyone.
        </p>
      </div>
    </section>
  );
};

export default CodeOfConductSection;
